const About = ({ overview, jobs, skills, services }) => {
  const _jobs = jobs.map(
    ({ company, position, duration, detail }, index, array) => {
      if (index % 2) {
        return null;
      }
      return (
        <div className="item-c" key={duration}>
          <div className="item mb-30">
            <h4>{company}</h4>
            <span className="meta">{duration}</span>
            <h5>{position}</h5>
            <p dangerouslySetInnerHTML={{ __html: detail }}></p>
          </div>
          {index + 1 < array.length && (
            <div className="item mb-30">
              <h4>{array[index + 1].company}</h4>
              <span className="meta">{array[index + 1].duration}</span>
              <h5>{array[index + 1].position}</h5>
              <p
                dangerouslySetInnerHTML={{ __html: array[index + 1].detail }}
              ></p>
            </div>
          )}
        </div>
      );
    }
  );

  const _skills = skills.map(({ name, level }) => (
    <div className="skills-item mb-30" key={name}>
      <h4>{name}</h4>
      <div className="bar">
        <span className="fill" data-width={`${level}%`}></span>
      </div>
      <div className="tip"></div>
    </div>
  ));

  const _services = services.map(({ name, icon, detail }, index) => (
    <div className="services-box box" key={name}>
      <div className="icon mb-20">
        <img src={icon} />
      </div>
      <div className="text">
        <h3>0{index + 1}</h3>
        <h4 className="box-title mb-20">{name}</h4>
        <p dangerouslySetInnerHTML={{ __html: detail }}></p>
      </div>
    </div>
  ));

  return (
    <section id="about" className="about section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title text-center">
              <div className="content">
                <h3>About Me</h3>
              </div>
            </div>
          </div>

          <div className="col-lg-4 sm-mb-50">
            <div className="box-info">
              <h2>Personal Info</h2>

              <h5
                className="mb-30"
                dangerouslySetInnerHTML={{
                  __html: overview,
                }}
              />

              <h2>Skills & abilities</h2>

              {_skills}

              <a href="#">
                <div className="inner-button">
                  <span>Download CV</span>
                </div>
              </a>
            </div>
          </div>

          <div className="col-lg-4 sm-mb-50">
            <div
              className="box-img cover-bg"
              data-image-src="img/hero-about.jpg"
            >
              <img src="img/hero-about.jpg" alt="" />
            </div>
          </div>

          <div className="col-lg-4">
            <div className="box-text">
              <div className="content">
                <h2>Jobs & Education</h2>

                <div className="owl-carousel">{_jobs}</div>
              </div>
            </div>
          </div>

          <div className="col-12 services mt-70">
            <div className="owl-carousel">{_services}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
